import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export type SurfaceId = 'phone' | 'x-clone' | 'email' | 'tv' | 'globe' | 'wallet' | 'calendar';

export const ALL_SURFACES: SurfaceId[] = [
  'phone', 'x-clone', 'email', 'tv', 'globe', 'wallet', 'calendar',
];

interface SurfacesStore {
  active: SurfaceId | null;
  unreadCounts: Record<SurfaceId, number>;
  open: (id: SurfaceId) => void;
  close: () => void;
  toggle: (id: SurfaceId) => void;
  bumpUnread: (id: SurfaceId, n?: number) => void;
  clearUnread: (id: SurfaceId) => void;
}

const zeroCounts = (): Record<SurfaceId, number> => ({
  phone: 0,
  'x-clone': 0,
  email: 0,
  tv: 0,
  globe: 0,
  wallet: 0,
  calendar: 0,
});

export const useSurfaces = create<SurfacesStore>()(
  immer((set) => ({
    active: null,
    unreadCounts: zeroCounts(),
    open: (id) => set((s) => { s.active = id; s.unreadCounts[id] = 0; }),
    close: () => set((s) => { s.active = null; }),
    toggle: (id) => set((s) => {
      if (s.active === id) {
        s.active = null;
      } else {
        s.active = id;
        s.unreadCounts[id] = 0;
      }
    }),
    bumpUnread: (id, n = 1) => set((s) => { s.unreadCounts[id] += n; }),
    clearUnread: (id) => set((s) => { s.unreadCounts[id] = 0; }),
  })),
);
